import {
  useCreateMonitoringEventMutation,
  useLazyGetMonitoringEventQuery,
  useLazySelectMonitoringEventQuery,
  useUpdateMonitoringEventMutation
} from 'src/services/monitoringEvent';
import {
  useGetUnscheduledVisitCrfsMutation,
  useCreateUnschedulesVisitEventMutation
} from 'src/services/patientDetails';

export const useClenderEvents = () => {
  const [
    getMonitoringEvent,
    {
      data: monitoringEventData,
      isLoading: monitoringEventIsLoading,
      isError: monitoringEventIsError,
      error: monitoringEventError,
      isSuccess: monitoringEventIsSuccess
    }
  ] = useLazyGetMonitoringEventQuery();

  const [
    createMonitoringEvent,
    {
      data: createMonitoringData,
      isLoading: createMonitoringIsLoading,
      isError: createMonitoringIsError,
      error: createMonitoringError,
      isSuccess: createMonitoringIsSuccess
    }
  ] = useCreateMonitoringEventMutation();

  const [
    updateMonitoringEvent,
    {
      data: updateMonitoringEventData,
      isLoading: updateMonitoringEventIsLoading,
      isError: updateMonitoringEventIsError,
      error: updateMonitoringEventError,
      isSuccess: updateMonitoringEventIsSuccess
    }
  ] = useUpdateMonitoringEventMutation();

  const [
    selectMonitoringEvent,
    {
      data: selectMonitoringEventData,
      isLoading: selectMonitoringEventIsLoading,
      isError: selectMonitoringEventIsError,
      error: selectMonitoringEventError,
      isSuccess: selectMonitoringEventIsSuccess
    }
  ] = useLazySelectMonitoringEventQuery();

  const [
    createUnscheduledVisit,
    {
      data: createUnscheduledVisitData,
      isLoading: createUnscheduledVisitIsLoading,
      isError: createUnscheduledVisitIsError,
      error: createUnscheduledVisitError,
      isSuccess: createUnscheduledVisitIsSuccess
    }
  ] = useCreateUnschedulesVisitEventMutation();

  const [
    getUnscheduledVisitCrfs,
    {
      data: unscheduledVisitCrfsData,
      isLoading: unscheduledVisitCrfsIsLoading,
      isError: unscheduledVisitCrfsIsError,
      error: unscheduledVisitCrfsError,
      isSuccess: unscheduledVisitCrfsIsSuccess
    }
  ] = useGetUnscheduledVisitCrfsMutation();

  return {
    getMonitoringEvent,
    monitoringEventData,
    monitoringEventIsError,
    monitoringEventIsLoading,
    monitoringEventError,
    monitoringEventIsSuccess,
    createMonitoringEvent,
    createMonitoringData,
    createMonitoringIsLoading,
    createMonitoringIsError,
    createMonitoringError,
    createMonitoringIsSuccess,
    updateMonitoringEvent,
    updateMonitoringEventData,
    updateMonitoringEventIsLoading,
    updateMonitoringEventIsError,
    updateMonitoringEventError,
    updateMonitoringEventIsSuccess,
    selectMonitoringEvent,
    selectMonitoringEventData,
    selectMonitoringEventIsLoading,
    selectMonitoringEventIsError,
    selectMonitoringEventError,
    selectMonitoringEventIsSuccess,
    createUnscheduledVisit,
    createUnscheduledVisitData,
    createUnscheduledVisitIsLoading,
    createUnscheduledVisitIsError,
    createUnscheduledVisitError,
    createUnscheduledVisitIsSuccess,
    getUnscheduledVisitCrfs,
    unscheduledVisitCrfsData,
    unscheduledVisitCrfsIsLoading,
    unscheduledVisitCrfsIsError,
    unscheduledVisitCrfsError,
    unscheduledVisitCrfsIsSuccess
  };
};
